export var isExperimentEnabled = function (experimentStore, experimentName) {
  return experimentStore && experimentStore.exposures && experimentStore.exposures[experimentName] && experimentStore.exposures[experimentName].bucket > 0;
};